import React, { Component } from 'react';
import classNames from 'classnames';

import TextField from 'react-md/lib/TextFields'

import './TextFieldEdit.css'

class TextFieldEdit extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value
		};
	}

	handleOnChange = (value) => this.setState({	value: value });

	handleOnKeyPress = (e) => e.key === 'Enter' && e.target.blur();

	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.props.value) {
			this.setState({
				value: nextProps.value
			});
		}
	}

	render() {
		const {
			id = "",
			label = "",
			rows = 1,
			onSubmit,
			type = 'title',
			rightIcon = null
		} = this.props;

		const { value } = this.state;

		return <TextField
			id={id}
			ref={c => this.textField = c}
			className={classNames('textfield-edit', { [`textfield-edit-${type}`]: true })}
			label={label}
			//placeholder={label}
			rows={rows}
			value={value}
			//onClick={this.handleOnFocus}
			onBlur={e => onSubmit(e.target.value)}
			onChange={this.handleOnChange}
			onKeyPress={this.handleOnKeyPress}
			rightIcon={rightIcon}
		/>
	}
}

export default TextFieldEdit;



// WEBPACK FOOTER //
// ./src/components/common/TextFieldEdit.jsx